module.exports = __webpack_public_path__ + "static/media/direkonsiliasi.cdf69727.svg";